import { DocumentType } from '@backrs_ui/grow-ui/src/models/models';

import { createApi } from '@reduxjs/toolkit/query/react';

import { lubavAppBaseQuery } from '../baseQuery';

export type DocumentInfo = Readonly<{
  filename: string | null;
  url: string | null;
  confirmed: boolean;
}>;

export type UserDocuments = Readonly<{
  [key in DocumentType]: DocumentInfo;
}>;

type CheckUserDocumentsParams = Readonly<{
  userId: number;
  documents: DocumentType[];
}>;

export const userDocumentsApi = createApi({
  reducerPath: 'userDocumentsApi',
  baseQuery: lubavAppBaseQuery,
  endpoints: (build) => ({
    checkUserDocuments: build.query<UserDocuments, CheckUserDocumentsParams>({
      query: ({ userId, documents }) => {
        const searchParams = new URLSearchParams();

        searchParams.append('user_id', userId.toString());
        documents.forEach((doc) => searchParams.append('documents', doc));

        return {
          url: `/api/check-user-documents?${searchParams.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useCheckUserDocumentsQuery } = userDocumentsApi;
